var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 13.8333H3.21824L11.7487 5.30288L10.6974 4.25163L2.16699 12.782V13.8333ZM0.916992 15.0833V12.2629L11.9091 1.27558C12.035 1.16114 12.1741 1.07274 12.3264 1.01038C12.4787 0.947876 12.6385 0.916626 12.8055 0.916626C12.9726 0.916626 13.1344 0.946279 13.291 1.00558C13.4476 1.06489 13.5863 1.15919 13.707 1.2885L14.7247 2.31892C14.854 2.43961 14.9462 2.5785 15.0012 2.73558C15.0562 2.89267 15.0837 3.04975 15.0837 3.20683C15.0837 3.37447 15.055 3.5344 14.9978 3.68663C14.9406 3.83899 14.8496 3.97815 14.7247 4.10413L3.73741 15.0833H0.916992ZM11.2139 4.78642L10.6974 4.25163L11.7487 5.30288L11.2139 4.78642Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit_pen.9657a1eca52d89c6b1a1d04db6932637.svg";
export { ForwardRef as ReactComponent };